<template>
  <article class="fcc">
    <div class="fcc__top">
      <span class="fcc__id">{{ card.label }}</span>
      <span v-if="card.partial" class="fcc__badge">{{ partialBadge }}</span>
    </div>
    <div class="fcc__title">{{ card.objectName }}</div>
    <div v-if="card.address" class="fcc__address">{{ card.address }}</div>
    <div class="fcc__closed"><span class="fcc__meta-label">Завершено</span> {{ card.closedAt }}</div>
    <ul v-if="card.works.length" class="fcc__works">
      <li v-for="w in card.works" :key="w.id" class="fcc__work" :class="{ 'fcc__work--done': w.done }">{{ w.title }}</li>
    </ul>
    <div v-if="card.dispatcherComment" class="fcc__comment fcc__comment--dispatcher"><b>Диспетчер.</b> {{ card.dispatcherComment }}</div>
    <div v-if="card.engineerComment" class="fcc__comment fcc__comment--engineer"><b>Инженер.</b> {{ card.engineerComment }}</div>
  </article>
</template>

<script>
import { PARTIAL_BADGE } from '@/components/field/fieldTasksLogic';

/** One completed task (KOP-40 spec §6.4). Dumb: renders a `completedCardModel()`. */
export default {
  name: 'CompletedTaskCard',
  props: {
    card: { type: Object, required: true },
  },
  computed: {
    partialBadge() { return PARTIAL_BADGE; },
  },
};
</script>

<style scoped lang="scss">
.fcc { background: #fff; border: 1px solid #e3e5e1; border-radius: 12px; padding: 12px 14px; display: flex; flex-direction: column; gap: 6px; font-size: 13px; color: #1d221f; }
.fcc__top { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.fcc__id { font-family: SFMono-Regular, Menlo, monospace; font-size: 12px; color: #8b918c; }
.fcc__badge { background: #fdf3e1; color: #9a6a00; font-size: 10.5px; font-weight: 800; padding: 2px 6px; border-radius: 5px; }
.fcc__title { font-weight: 700; font-size: 15px; }
.fcc__address { color: #8b918c; }
.fcc__closed { color: #4c524d; }
.fcc__meta-label { color: #8b918c; font-size: 11.5px; margin-right: 4px; }
.fcc__works { list-style: none; padding: 0; margin: 2px 0 0; display: flex; flex-direction: column; gap: 3px; }
.fcc__work { position: relative; padding-left: 16px; &::before { content: ''; position: absolute; left: 2px; top: 6px; width: 8px; height: 8px; border-radius: 50%; background: #c3c8c3; } }
.fcc__work--done::before { background: #17876f; }
.fcc__comment { background: #f4f5f1; border-radius: 8px; padding: 8px 10px; color: #4c524d; b { color: #8b918c; font-weight: 700; } }
</style>
